import { useTranslation } from 'react-i18next';

const RefreshingBanner = ({ show = false, label }) => {
  const { t } = useTranslation();
  if (!show) return null;
  return (
    <div className="mb-3 flex items-center gap-2 text-xs text-gray-500">
      <span className="h-3 w-3 shrink-0 animate-spin rounded-full border-2 border-gray-200 border-t-gray-600" />
      <span>{label || t('dashboard.updating')}</span>
    </div>
  );
};

export default RefreshingBanner;
